/*    
<summary>
   This functional common component provides us custom input select boxfor single or multiple selection & has error handler that shows validation error. 
   Developer:Aashish Singh, Created Date:13-Nov-2024
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";
import { injectIntl } from "react-intl";
import FormikFormErrorHandler from "./FormikFormErrorHandler";
import { useField } from "formik";
import FormikRelayInfoFormErrorHandler from "./FormikFormRelayErrorHandler";
import { formatMessage } from "../../translations/format-message";
import Select, { StylesConfig } from "react-select";


interface IProps {
  children: React.ReactNode;
  className: string;
  errclassname: string | undefined;
  "data-testid"?: string;
  intl: any; //IntlConfig;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  placeholder: string;
  type: string;
  value: string;
  disabled: boolean;
  options:any[];
  isMulti: boolean;
  isSearchable: boolean;
  isDisabled: boolean;
  isLoading: boolean;
  isClearable: boolean;
}
export interface ColourOption {
  readonly value: string;
  readonly label: string;
  readonly color: string;
  readonly isFixed?: boolean;
  readonly isDisabled?: boolean;
}

const FormikFormInputMultipleSelect = (props: IProps) => {
  const [field, meta, helpers] = useField(props);
  const [value, setValue] = useState<any>("");
  const colourStyles: StylesConfig<ColourOption, true> = {
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const backgroundColor = isDisabled
        ? undefined
        : isSelected
        ? '#ff6c37'
        : isFocused
        ? `#ff6c37` // Using hex transparency (10% opacity)
        : undefined;
  
      const color = isDisabled
        ? '#ccc'
        : isSelected
        ? '#fff' // Default to white for selected options
        : isFocused
        ? `#fff`
        : undefined;
  
      return {
        ...styles,
        backgroundColor,
        color,
        cursor: isDisabled ? 'not-allowed' : 'default',
        
      };
    },
    
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: undefined,
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: undefined,
      ':hover': {
        backgroundColor: '#dc35454a',
        color: '#dc3545',
      },
    }),
  };

  const handleChange = (selectedOption:any[]) => {
    helpers.setValue(selectedOption);
  };

  return (
    <>
      <Select
        {...field}
        {...props}
        options={props.options}
        classNamePrefix="select"
        onChange={handleChange}
        isMulti={props.isMulti}
        isSearchable={props.isSearchable}
        isDisabled={props.isDisabled}
        isLoading={props.isLoading}
        isClearable={props.isClearable}
        value={field.value}
        styles={colourStyles}
        noOptionsMessage={() => formatMessage("no_data_found")}
      />
      <FormikFormErrorHandler intl={props.intl} meta={meta} />
    </>
  );
};

export default injectIntl(FormikFormInputMultipleSelect);
